import React, { useEffect, useState } from 'react';
import { Loading } from '../../Components';
import { useParams, useNavigate } from 'react-router-dom';
import { getToolsFromFirestore, addToolToFirestore, deleteToolFromFirestore } from '../../firebase/toolService';
import { uploadToolImage } from '../../firebase/storageService';
import { useAuth } from '../../firebase/AuthContext';
import styles from './ToolEdit.module.css';
import ToolInput from '../../Components/ToolInput/ToolInput';

const ToolEdit = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [tool, setTool] = useState(null);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [genre, setGenre] = useState('');
  const [brand, setBrand] = useState('');
  const [color, setColor] = useState('');
  const [genreList, setGenreList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [colorList, setColorList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    (async () => {
      const tools = await getToolsFromFirestore(user.uid);
      const found = tools.find(t => t.id === id);
      setTool(found || null);
      if (found) {
        setName(found.name || '');
        setDescription(found.description || '');
        setImages(found.images || []);
        setGenre(found.genre || '');
        setBrand(found.brand || '');
        setColor(found.color || '');
      }
      // マスターリストも取得
      const [genres, brands, colors] = await Promise.all([
        import('../../firebase/genreService').then(m => m.getGenresFromFirestore(user.uid)),
        import('../../firebase/brandService').then(m => m.getBrandsFromFirestore(user.uid)),
        import('../../firebase/colorService').then(m => m.getColorsFromFirestore(user.uid)),
      ]);
      setGenreList(genres);
      setBrandList(brands);
      setColorList(colors);
      // リスト取得後に再セット（初期値反映用）
      if (found) {
        if (found.genre) setGenre(found.genre);
        if (found.brand) setBrand(found.brand);
        if (found.color) setColor(found.color);
      }
    })();
  }, [user, id]);

  const handleImageChange = (e) => {
    setNewImages(Array.from(e.target.files).slice(0, 3));
  };

  const handleSave = async () => {
    if (!name.trim()) {
      // 必須チェックのみalert維持
      alert('名前は必須です');
      return;
    }
    setLoading(true);
    let imageUrls = images;
    try {
      if (newImages.length > 0 && user) {
        imageUrls = await Promise.all(
          newImages.map((file, idx) => uploadToolImage(file, user.uid, name.trim(), idx))
        );
      }
      // Firestoreの既存データを一度削除して新規追加（IDは変わる）
      await deleteToolFromFirestore(tool.id);
      await addToolToFirestore({
        name: name.trim(),
        description: description.trim(),
        images: imageUrls,
        genre: genre.trim(),
        brand: brand.trim(),
        color: color.trim(),
      });
      navigate('/tools/list');
    } finally {
      setLoading(false);
    }
  };

  if (!tool) return <div className={styles.container}>道具が見つかりません</div>;
  if (loading) return <Loading />;

  return (
    <div className={styles.container}>
      <button className={styles.button} style={{ marginBottom: 16 }} onClick={() => navigate('/tools/list')}>一覧に戻る</button>
      <h2>道具編集</h2>
      <ToolInput
        toolName={name}
        setToolName={setName}
        genre={genre}
        setGenre={setGenre}
        brand={brand}
        setBrand={setBrand}
        color={color}
        setColor={setColor}
        images={images}
        setImages={setImages}
        description={description}
        setDescription={setDescription}
        genreList={genreList}
        brandList={brandList}
        colorList={colorList}
        onSubmit={e => { e.preventDefault(); handleSave(); }}
        submitLabel="保存"
      />
    </div>
  );
};

export default ToolEdit;
